import './bootstrap';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import notificationPlugin from './plugins/notificationPlugin';
import dialogPlugin from './plugins/dialogPlugin';

// Import Bootstrap CSS and JS
import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/custom.css';
import '../css/dashboard-premium.css';
import '@popperjs/core';
import 'bootstrap';
import { createPinia } from 'pinia';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';

const app = createApp(App);
app.use(Antd);
app.use(createPinia());
app.use(router);
app.use(notificationPlugin);
app.use(dialogPlugin);
app.mount('#app');
